import urlcat from 'urlcat';

import { Routes } from 'src/constants/routes';

import { SearchParamKnownKeys } from 'src/hooks/useUrlSearchParams';

export enum JobDetailsTabs {
  JobStage = 'job_stage',
  HiringTeam = 'hiring-team',
  CandidatePortal = 'candidate-portal',
  Setup = 'setup',
  Sourcing = 'sourcing',
  Ai = 'ai',
}

/**
 *
 * @param jobId
 * @returns
 */
const getJobDetailsUrl = (
  jobId: string,
  tab: JobDetailsTabs,
  jobStageId?: string,
  extraParams?: { [key in SearchParamKnownKeys]?: string }
) => {
  if (jobStageId) {
    return urlcat('', Routes.JobDetailsWithJobStage, { jobId, jobStageId, tab, ...extraParams });
  }
  return urlcat('', Routes.JobDetails, { jobId, tab, ...extraParams });
};

export default getJobDetailsUrl;
